"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = handleCartErrors;
var _uxTreadNewRelic = require("@nike/ux-tread-new-relic");
var _sharedUtils = require("./shared-utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// Map of error codes that cause us to remove the product from the user's cart:
var notBuyableCodes = {
  PRODUCT_NOT_BUYABLE: true,
  OUT_OF_STOCK: true
};
var quantityLimitCodes = {
  ITEM_QUANTITY_LIMIT: true
};
var promoCodeErrorCodes = {
  PROMOTION_INVALID: true,
  PROMOTION_EXPIRED: true
};
var EVENT_NAME = 'Handling Cart Error';

/**
 * @ignore
 * @returns {Promise} result of handling cart errors
 */
function handleCartErrors(_x, _x2) {
  return _handleCartErrors.apply(this, arguments);
}
function _handleCartErrors() {
  _handleCartErrors = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, queryClient) {
    var _error$data, _error$data2;
    var error, params, data, errors, itemsToRemove, hasOverLimitItems, hasNonBuyableItems, hasInvalidPromoCodes, handleRemovePromotionCode, handleMergeCarts, _data$items, items, _items$, handleRemoveItem, _data$items2, _items$2, _items, _handleRemoveItem, _handleMergeCarts, _data$items3, _items2$, _items2, _handleRemoveItem2, _handleRemovePromotionCode, _handleMergeCarts2, _handleRemovePromotionCode2, _data$items4, _items3$, _items3, _handleRemoveItem3, _handleMergeCarts3, _handleRemovePromotionCode3;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          error = _ref.error, params = _ref.params;
          // Normalize common fetch/mutation error shapes into one cart+errors payload.
          data = error !== null && error !== void 0 && error.data && ((error === null || error === void 0 || (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.resourceType) === 'cart' || Array.isArray(error === null || error === void 0 || (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.items)) ? error.data : error;
          errors = (error === null || error === void 0 ? void 0 : error.errors) || (data === null || data === void 0 ? void 0 : data.errors); // 2. check for errors
          if (!(errors && errors.length)) {
            _context.n = 32;
            break;
          }
          // 3. reduce over errors that have fields
          itemsToRemove = errors.filter(function (e) {
            return e.field && typeof e.field === 'string';
          }).reduce(function (accum, curr) {
            // 4. check codes to see which errors need to be worked on
            var shouldFilterProduct = notBuyableCodes[curr.code] || quantityLimitCodes[curr.code] || promoCodeErrorCodes[curr.code];

            // 5. from the field string target the item by skuId eg:'item/0/skuId' | '/promotionCodes/0'
            // Add safety check to ensure field can be split and joined properly
            try {
              var fieldPath = curr.field.split('/').filter(function (x) {
                return x;
              }).join('.');
              if (!fieldPath) {
                // Invalid field path, skip this error
                (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
                  error: 'Invalid field path in error',
                  field: curr.field,
                  code: curr.code,
                  message: curr.message
                });
                return accum;
              }
              var filteredField = (0, _sharedUtils.getByPath)(data, fieldPath);

              // 6. if filtered field is a number
              var isANumber = !isNaN(filteredField) && filteredField !== undefined && filteredField !== null;
              if (isANumber) {
                // 7. from the field string target the line item id eg:'item/0/quantity'
                var lineItemId = curr.field.split('/').filter(function (x) {
                  return x;
                }).join('.').replace('quantity', 'id');
                var shouldAdjustQuantity = (0, _sharedUtils.getByPath)(data, lineItemId);

                // 8. if theres an error to be addressed
                return shouldFilterProduct ? _objectSpread(_objectSpread({}, accum), {}, {
                  reduceQuantity: _objectSpread(_objectSpread({}, accum.reduceQuantity), {}, _defineProperty({}, shouldAdjustQuantity, true))
                }) : accum;
              }

              // 10. if filtered field is not a number and there's an error to be addressed
              if (shouldFilterProduct) {
                if (promoCodeErrorCodes[curr.code]) {
                  return _objectSpread(_objectSpread({}, accum), {}, {
                    invalidPromoCodes: [].concat(_toConsumableArray(accum.invalidPromoCodes), [filteredField // 11. accumulate invalid promoCodes here
                    ])
                  });
                }
                return _objectSpread(_objectSpread({}, accum), {}, {
                  notBuyableSkus: _objectSpread(_objectSpread({}, accum.notBuyableSkus), {}, _defineProperty({}, filteredField, true))
                });
              }
              return accum;
            } catch (fieldError) {
              // If there's an error processing this field, log it and skip this error
              (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
                error: 'Error processing error field',
                field: curr.field,
                code: curr.code,
                message: curr.message,
                fieldError: fieldError.message
              });
              return accum;
            }
          }, {
            invalidPromoCodes: [],
            notBuyableSkus: {},
            reduceQuantity: {}
          }); // 13. determine if cart has any items over limit or has any non buyable items
          hasOverLimitItems = Object.keys(itemsToRemove.reduceQuantity).length > 0;
          hasNonBuyableItems = Object.keys(itemsToRemove.notBuyableSkus).length > 0;
          hasInvalidPromoCodes = itemsToRemove.invalidPromoCodes.length > 0; // 14. if there are invalid promos only
          if (!(hasInvalidPromoCodes && !hasNonBuyableItems && !hasOverLimitItems)) {
            _context.n = 3;
            break;
          }
          (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
            error: 'Invalid promotion codes detected',
            promotionCodes: itemsToRemove.invalidPromoCodes,
            errors: errors,
            data: data
          });
          _context.n = 1;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 1:
          handleRemovePromotionCode = _context.v["default"];
          _context.n = 2;
          return handleRemovePromotionCode(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            promotionCode: itemsToRemove.invalidPromoCodes[0] // this needs adjusting to handle a single code. Check how itemsToRemove is structured
          }));
        case 2:
          // 16. and in all cases afterwards, propagate the errors up
          errors.map(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.a(2, error);
        case 3:
          if (!(hasOverLimitItems && !hasNonBuyableItems && !hasInvalidPromoCodes)) {
            _context.n = 6;
            break;
          }
          (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
            error: 'Items over quantity limit detected',
            itemsWithQuantityLimits: Object.keys(itemsToRemove.reduceQuantity),
            errors: errors,
            data: data
          });
          _context.n = 4;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-merge-carts"));
          });
        case 4:
          handleMergeCarts = _context.v["default"];
          _context.n = 5;
          return handleMergeCarts({
            params: _objectSpread(_objectSpread({}, params), {}, {
              validateOnly: true
            }),
            queryClient: queryClient
          });
        case 5:
          // 19. propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.a(2, error);
        case 6:
          if (!(hasNonBuyableItems && !hasOverLimitItems && !hasInvalidPromoCodes)) {
            _context.n = 9;
            break;
          }
          items = ((_data$items = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items !== void 0 ? _data$items : []).filter(function (item) {
            return itemsToRemove.notBuyableSkus[item.skuId];
          });
          if (!items.length) {
            _context.n = 9;
            break;
          }
          (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
            error: 'Non-buyable items detected',
            nonBuyableItems: items.map(function (item) {
              return item.skuId;
            }),
            errors: errors,
            data: data
          });
          _context.n = 7;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-item"));
          });
        case 7:
          handleRemoveItem = _context.v["default"];
          _context.n = 8;
          return handleRemoveItem(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            id: (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.id
          }));
        case 8:
          // 22. propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.a(2, error);
        case 9:
          if (!(hasNonBuyableItems && hasOverLimitItems && !hasInvalidPromoCodes)) {
            _context.n = 14;
            break;
          }
          _items = ((_data$items2 = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items2 !== void 0 ? _data$items2 : []).filter(function (item) {
            return itemsToRemove.notBuyableSkus[item.skuId];
          });
          (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
            error: 'Both non-buyable items and items over quantity limit detected',
            nonBuyableItems: _items.map(function (item) {
              return item.skuId;
            }),
            itemsWithQuantityLimits: Object.keys(itemsToRemove.reduceQuantity),
            errors: errors,
            data: data
          });
          _context.n = 10;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-item"));
          });
        case 10:
          _handleRemoveItem = _context.v["default"];
          _context.n = 11;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-merge-carts"));
          });
        case 11:
          _handleMergeCarts = _context.v["default"];
          if (!(_items.length && (_items$2 = _items[0]) !== null && _items$2 !== void 0 && _items$2.id)) {
            _context.n = 12;
            break;
          }
          _context.n = 12;
          return _handleRemoveItem(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            id: _items[0].id
          }));
        case 12:
          _context.n = 13;
          return _handleMergeCarts({
            params: _objectSpread(_objectSpread({}, params), {}, {
              validateOnly: true
            }),
            queryClient: queryClient
          });
        case 13:
          // 26. propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.a(2, error);
        case 14:
          if (!(hasNonBuyableItems && !hasOverLimitItems && hasInvalidPromoCodes)) {
            _context.n = 19;
            break;
          }
          _items2 = ((_data$items3 = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items3 !== void 0 ? _data$items3 : []).filter(function (item) {
            return itemsToRemove.notBuyableSkus[item.skuId];
          });
          (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
            error: 'Both non-buyable items and invalid promotion codes detected',
            nonBuyableItems: _items2.map(function (item) {
              return item.skuId;
            }),
            promotionCodes: itemsToRemove.invalidPromoCodes,
            errors: errors,
            data: data
          });
          _context.n = 15;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-item"));
          });
        case 15:
          _handleRemoveItem2 = _context.v["default"];
          _context.n = 16;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 16:
          _handleRemovePromotionCode = _context.v["default"];
          if (!(_items2.length && (_items2$ = _items2[0]) !== null && _items2$ !== void 0 && _items2$.id)) {
            _context.n = 17;
            break;
          }
          _context.n = 17;
          return _handleRemoveItem2(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            id: _items2[0].id
          }));
        case 17:
          _context.n = 18;
          return _handleRemovePromotionCode(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            promotionCode: itemsToRemove.invalidPromoCodes[0] // this needs adjusting to handle a single code. Check how itemsToRemove is structured
          }));
        case 18:
          // 30. propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.a(2, error);
        case 19:
          if (!(!hasNonBuyableItems && hasOverLimitItems && hasInvalidPromoCodes)) {
            _context.n = 24;
            break;
          }
          (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
            error: 'Both items over quantity limit and invalid promotion codes detected',
            itemsWithQuantityLimits: Object.keys(itemsToRemove.reduceQuantity),
            promotionCodes: itemsToRemove.invalidPromoCodes,
            errors: errors,
            data: data
          });
          _context.n = 20;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-merge-carts"));
          });
        case 20:
          _handleMergeCarts2 = _context.v["default"];
          _context.n = 21;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 21:
          _handleRemovePromotionCode2 = _context.v["default"];
          _context.n = 22;
          return _handleMergeCarts2({
            params: _objectSpread(_objectSpread({}, params), {}, {
              validateOnly: true
            }),
            queryClient: queryClient
          });
        case 22:
          _context.n = 23;
          return _handleRemovePromotionCode2(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            promotionCode: itemsToRemove.invalidPromoCodes[0] // this needs adjusting to handle a single code. Check how itemsToRemove is structured
          }));
        case 23:
          // 34. then propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.a(2, error);
        case 24:
          if (!(hasNonBuyableItems && hasOverLimitItems && hasInvalidPromoCodes)) {
            _context.n = 31;
            break;
          }
          _items3 = ((_data$items4 = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items4 !== void 0 ? _data$items4 : []).filter(function (item) {
            return itemsToRemove.notBuyableSkus[item.skuId];
          });
          (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
            error: 'Multiple cart issues detected: non-buyable items, items over quantity limit, and invalid promotion codes',
            nonBuyableItems: _items3.map(function (item) {
              return item.skuId;
            }),
            itemsWithQuantityLimits: Object.keys(itemsToRemove.reduceQuantity),
            promotionCodes: itemsToRemove.invalidPromoCodes,
            errors: errors,
            data: data
          });
          _context.n = 25;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-item"));
          });
        case 25:
          _handleRemoveItem3 = _context.v["default"];
          _context.n = 26;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-merge-carts"));
          });
        case 26:
          _handleMergeCarts3 = _context.v["default"];
          _context.n = 27;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../api-calls/handle-remove-promotion-code"));
          });
        case 27:
          _handleRemovePromotionCode3 = _context.v["default"];
          if (!(_items3.length && (_items3$ = _items3[0]) !== null && _items3$ !== void 0 && _items3$.id)) {
            _context.n = 28;
            break;
          }
          _context.n = 28;
          return _handleRemoveItem3(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            id: _items3[0].id
          }));
        case 28:
          _context.n = 29;
          return _handleMergeCarts3({
            params: _objectSpread(_objectSpread({}, params), {}, {
              validateOnly: true
            }),
            queryClient: queryClient
          });
        case 29:
          _context.n = 30;
          return _handleRemovePromotionCode3(_objectSpread(_objectSpread({}, params), {}, {
            queryClient: queryClient,
            promotionCode: itemsToRemove.invalidPromoCodes[0] // this needs adjusting to handle a single code. Check how itemsToRemove is structured
          }));
        case 30:
          // 39. then propagate the errors up
          errors.forEach(function (err) {
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.a(2, error);
        case 31:
          errors.forEach(function (err) {
            var message = err.message,
              crcCode = err.crcCode,
              code = err.code,
              field = err.field;
            // 40. if we have errors after handling the above cases afterwards, propagate them up
            (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
              error: 'Unhandled cart error',
              errorCode: code,
              errorMessage: message,
              crcCode: crcCode,
              field: field,
              errors: errors,
              data: data
            });
            window.NikeShop.__INTERNAL_USE__.stores.errorModal.displayErrorModal(err);
          });
          return _context.a(2, error);
        case 32:
          // 41. if no errors, then propagate the entire error up
          (0, _uxTreadNewRelic.addPageAction)(EVENT_NAME, {
            error: 'General cart error without error details',
            errorMessage: error.message || 'Unknown error',
            errors: errors,
            data: data
          });

          // Return error data for handling RQ errors
          return _context.a(2, error);
      }
    }, _callee);
  }));
  return _handleCartErrors.apply(this, arguments);
}